import { render, staticRenderFns } from "./OphthalmologyDetail.vue?vue&type=template&id=18f1aafa"
import script from "./OphthalmologyDetail.vue?vue&type=script&lang=js"
export * from "./OphthalmologyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports